import { Grid, Typography, Box, Card, CardContent, CircularProgress } from '@mui/material';
import PropTypes from 'prop-types';
import { Line } from 'react-chartjs-2';


export default function DashboardTrends({
    trendBarChartOptions,
    chartData,
    scoreMetricsByDate,
}) {

    const TrendCard = ({ title, subtitle, chartData, loading, error }) => (
        <Card elevation={0} sx={{ height: '100%' }}>
            <CardContent sx={{ p: 3 }}>
                <Typography
                    variant="h6"
                    sx={{ fontSize: '1rem', fontWeight: 600, mb: 0.5 }}
                >
                    {title}
                </Typography>
                <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ fontSize: '0.75rem', mb: 2 }}
                >
                    {subtitle}
                </Typography>
                <Box sx={{ height: 200 }}>
                    {loading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <CircularProgress size={24} />
                        </Box>
                    ) : error ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', color: 'text.secondary' }}>
                            <Typography variant="body2">Erro ao carregar dados</Typography>
                        </Box>
                    ) : !chartData || !chartData.labels || chartData.labels.length === 0 ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', color: 'text.secondary' }}>
                            <Typography variant="body2">Sem dados para exibir</Typography>
                        </Box>
                    ) : (
                        <Line data={chartData} options={trendBarChartOptions} />
                    )}
                </Box>
            </CardContent>
        </Card>
    );

    TrendCard.propTypes = {
        title: PropTypes.string.isRequired,
        subtitle: PropTypes.string.isRequired,
        chartData: PropTypes.shape({
            labels: PropTypes.array,
            datasets: PropTypes.array,
        }),
        loading: PropTypes.bool.isRequired,
        error: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.bool]),
    };

    return (
        <Grid container spacing={3}>

            <Grid item xs={12} md={4}>
                <TrendCard
                    title="Média do Score diário"
                    subtitle="Variação da média por dia."
                    chartData={chartData.averageScoreByDay}
                    loading={scoreMetricsByDate.loading}
                    error={scoreMetricsByDate.error}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TrendCard
                    title="Score máximo diário"
                    subtitle="Variação do valor máximo por dia."
                    chartData={chartData.maxScoreByDay}
                    loading={scoreMetricsByDate.loading}
                    error={scoreMetricsByDate.error}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TrendCard
                    title="Score mínimo diário"
                    subtitle="Variação do valor mínimo por dia."
                    chartData={chartData.minScoreByDay}
                    loading={scoreMetricsByDate.loading}
                    error={scoreMetricsByDate.error}
                />
            </Grid>

        </Grid>
    )
}

